import { WATERMARK } from './watermark.token';

export const provideWatermark = (watermark?: string) => [
    {
        provide: WATERMARK,
        useValue: watermark ?? '',
    },
];
